// mfaWarning.ts
interface DisplayMfaWarningOptions {
  context: { controller: string };
  siteCode: string;
  translate: (key: string) => string;
}

export function displayMfaWarning({
  context,
  siteCode,
  translate,
}: DisplayMfaWarningOptions) {
  const mfaWarningMessage = translate(
    `OktaWidget.MfaRequiredMessage_${siteCode}`
  );

  // Target the header element
  const headerElement = document.querySelector(
    '.okta-sign-in-header.auth-header'
  ) as HTMLElement;

  // Remove any existing MFA warning
  const existingMfaWarning = headerElement?.querySelector('.mfa-warning');
  if (existingMfaWarning) {
    existingMfaWarning.remove();
  }

  // 2FA warning text
  if (
    mfaWarningMessage &&
    mfaWarningMessage !== `OktaWidget.MfaRequiredMessage_${siteCode}` &&
    context.controller === 'primary-auth'
  ) {
    const mfaWarning = document.createElement('div');
    mfaWarning.textContent = mfaWarningMessage;
    mfaWarning.style.color = 'brown';
    mfaWarning.style.margin = '0';
    mfaWarning.style.display = 'contents';
    mfaWarning.style.fontSize = '16px';
    mfaWarning.style.fontWeight = 'bold';
    mfaWarning.className = 'mfa-warning';

    if (headerElement) {
      headerElement.style.paddingLeft = '0';
      headerElement.style.paddingRight = '0';
      headerElement.prepend(mfaWarning);
    }
  }
}
